import { useModuleEndpoint } from './useModuleEndpoint';

export function useModuleConfig(moduleId: number, subpath = '') {
  const {
    response: moduleConfig = {},
    getEndpoint: fetchModuleConfig,
    isFetching,
    hasJustFinishedFetching,
    error: configError,
  } = useModuleEndpoint(moduleId, `${subpath}/config`);

  const {
    response: saveResponse = {},
    postEndpoint: saveModuleConfig,
    isFetching: isSaving,
    hasJustFinishedFetching: hasJustFinishedSaving,
    error: saveError,
  } = useModuleEndpoint(moduleId, `${subpath}/save`);

  return {
    error: saveError || configError,
    isSaving,
    isFetching,
    moduleConfig,
    saveResponse,
    saveModuleConfig,
    fetchModuleConfig,
    hasJustFinishedFetching,
    hasJustFinishedSaving,
  };
}
